import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-16 md:py-24 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            Browse Product Categories
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg">
            Explore curated product collections across all major categories. Each link leads directly to verified supplier resources.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 hover:shadow-sm"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 text-center">
                <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg mb-3">
                  {cat.name}
                </h3>
                <span
                  className={`inline-block px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                    index === 0
                      ? "bg-foreground-950 text-background-50 hover:bg-foreground-800"
                      : "bg-background-50 text-foreground-800 border border-foreground-300 hover:border-foreground-500 hover:text-foreground-950"
                  }`}
                >
                  Shop {cat.name}
                </span>
                <p className="mt-3 text-foreground-500 text-xs">
                  Verified suppliers and pricing data
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}